export const useIsMergedLotteryPage = (_lotteryId: unknown) =>
  useIsFeatureFlagEnabled('mergedLotteryPage')
